"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfectionInstance = void 0;

var Infecter_1 = require("./Infecter");

var Utils_1 = require("../../Utils");

var InfectionInstance = /*#__PURE__*/function () {
  function InfectionInstance(container) {
    _classCallCheck(this, InfectionInstance);

    this.container = container;
    this.container.infecter = new Infecter_1.Infecter(this.container);
  }

  _createClass(InfectionInstance, [{
    key: "particlesSetup",
    value: function particlesSetup() {
      var _a;

      var options = this.container.actualOptions;

      for (var i = 0; i < options.infection.infections; i++) {
        var notInfected = this.container.particles.array.filter(function (p) {
          var infP = p;

          if (!infP.infection) {
            infP.infection = {};
          }

          return infP.infection.stage === undefined;
        });
        var infected = Utils_1.itemFromArray(notInfected);
        (_a = this.container.infecter) === null || _a === void 0 ? void 0 : _a.startInfection(infected, 0);
      }
    }
  }, {
    key: "particleFillColor",
    value: function particleFillColor(particle) {
      var infParticle = particle;
      var options = this.container.actualOptions;

      if (!infParticle.infection) {
        return;
      }

      var infectionStage = infParticle.infection.stage;
      var infection = options.infection;
      var infectionStages = infection.stages;
      return infectionStage !== undefined ? infectionStages[infectionStage].color : undefined;
    }
  }, {
    key: "particleStrokeColor",
    value: function particleStrokeColor(particle) {
      return this.particleFillColor(particle);
    }
  }]);

  return InfectionInstance;
}();

exports.InfectionInstance = InfectionInstance;